(function () {
    // Theme toggle (dark/light)
    var themeBtn = document.getElementById('theme-toggle');
    var root = document.documentElement;
    var metaColor = document.getElementById('meta-theme-color');

    function applyTheme(theme) {
        root.setAttribute('data-theme', theme);
        if (metaColor) metaColor.content = theme === 'light' ? '#F3F1EB' : '#080808';
        try { localStorage.setItem('hxa-theme', theme); } catch (e) {}
    }

    if (themeBtn) {
        themeBtn.addEventListener('click', function () {
            var current = root.getAttribute('data-theme') || 'dark';
            applyTheme(current === 'dark' ? 'light' : 'dark');
        });
    }

    // Mobile nav
    var toggle = document.querySelector('.nav__toggle');
    var menu = document.getElementById('nav-menu');
    if (toggle && menu) {
        var setOpen = function (open) {
            toggle.setAttribute('aria-expanded', String(open));
            menu.classList.toggle('is-open', open);
        };
        toggle.addEventListener('click', function () {
            setOpen(toggle.getAttribute('aria-expanded') !== 'true');
        });
        menu.addEventListener('click', function (e) {
            if (e.target.closest('a')) setOpen(false);
        });
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') setOpen(false);
        });
    }

    // Accent color picker (easter egg)
    var accentDot = document.getElementById('accent-dot');
    var accentPalette = document.getElementById('accent-palette');
    if (accentDot && accentPalette) {
        try {
            var saved = localStorage.getItem('hxa-accent');
            if (saved) {
                root.style.setProperty('--color-circuit', saved);
                accentPalette.querySelectorAll('.accent-swatch').forEach(function (s) {
                    s.classList.toggle('is-active', s.dataset.color === saved);
                });
            }
        } catch (e) {}

        var skipClose = false;
        accentDot.addEventListener('click', function () {
            var open = accentPalette.getAttribute('aria-hidden') === 'false';
            accentPalette.setAttribute('aria-hidden', String(open));
            accentDot.setAttribute('aria-expanded', String(!open));
            skipClose = true;
        });

        accentPalette.addEventListener('click', function (e) {
            var swatch = e.target.closest('.accent-swatch');
            if (!swatch) return;
            var color = swatch.dataset.color;
            root.style.setProperty('--color-circuit', color);
            accentPalette.querySelectorAll('.accent-swatch').forEach(function (s) {
                s.classList.toggle('is-active', s === swatch);
            });
            try { localStorage.setItem('hxa-accent', color); } catch (e) {}
            skipClose = true;
        });

        document.addEventListener('click', function () {
            if (skipClose) { skipClose = false; return; }
            accentPalette.setAttribute('aria-hidden', 'true');
            accentDot.setAttribute('aria-expanded', 'false');
        });
    }

    // Scroll progress bar
    var progressBar = document.getElementById('scroll-progress');

    // Nav background after scroll
    var nav = document.querySelector('.nav');
    var onScroll = function () {
        nav.classList.toggle('is-scrolled', window.scrollY > 8);
        if (progressBar) {
            var h = document.documentElement.scrollHeight - window.innerHeight;
            progressBar.style.width = h > 0 ? (window.scrollY / h * 100) + '%' : '0';
        }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    // Active nav section highlighting (links may be "#id" or "/#id")
    var navLinks = document.querySelectorAll('.nav__menu a[href*="#"]');
    var sections = [];
    navLinks.forEach(function (link) {
        var href = link.getAttribute('href') || '';
        var hashIndex = href.indexOf('#');
        if (hashIndex === -1) return;
        var id = href.slice(hashIndex + 1);
        if (!id) return;
        var section = document.getElementById(id);
        if (section) sections.push({ el: section, link: link });
    });
    if (sections.length && 'IntersectionObserver' in window) {
        var activeIO = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                var match = sections.find(function (s) { return s.el === entry.target; });
                if (match) match.link.classList.toggle('is-section-active', entry.isIntersecting);
            });
        }, { rootMargin: '-30% 0px -60% 0px' });
        sections.forEach(function (s) { activeIO.observe(s.el); });
    }

    // Stat count-up animation
    var statNums = document.querySelectorAll('.stat__n');
    if (statNums.length && 'IntersectionObserver' in window) {
        var countIO = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                var el = entry.target;
                countIO.unobserve(el);
                var raw = el.textContent.trim();
                var suffix = raw.replace(/[\d.]/g, '');
                var target = parseFloat(raw);
                if (isNaN(target)) { el.classList.add('is-counted'); return; }
                var start = 0;
                var duration = 1200;
                var startTime = null;
                function animate(ts) {
                    if (!startTime) startTime = ts;
                    var progress = Math.min((ts - startTime) / duration, 1);
                    var ease = 1 - Math.pow(1 - progress, 3);
                    var current = Math.round(ease * target);
                    el.textContent = current + suffix;
                    if (progress < 1) requestAnimationFrame(animate);
                    else el.classList.add('is-counted');
                }
                el.classList.add('is-counted');
                requestAnimationFrame(animate);
            });
        }, { threshold: 0.5 });
        statNums.forEach(function (el) { countIO.observe(el); });
    }


    // Reveal on scroll (subtle, one-shot)
    var items = document.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
                if (en.isIntersecting) {
                    en.target.classList.add('is-in');
                    io.unobserve(en.target);
                }
            });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
        items.forEach(function (el) { io.observe(el); });
    } else {
        items.forEach(function (el) { el.classList.add('is-in'); });
    }

    // Case study filters + progressive "load more"
    var filterBtns = document.querySelectorAll('.case-filter');
    var caseCards = Array.prototype.slice.call(document.querySelectorAll('#cases-grid .card--case'));
    var loadMoreBtn = document.getElementById('cases-more');
    var countEl = loadMoreBtn ? loadMoreBtn.querySelector('.cases-more__count') : null;
    var BATCH = 3;
    var currentFilter = 'all';
    var shownCount = BATCH;

    function matchingCards() {
        return caseCards.filter(function (card) {
            return currentFilter === 'all' || card.dataset.category === currentFilter;
        });
    }

    function applyCases(reveal) {
        var matches = matchingCards();
        caseCards.forEach(function (card) { card.classList.add('is-hidden'); });
        matches.slice(0, shownCount).forEach(function (card) {
            card.classList.remove('is-hidden');
            if (reveal) card.classList.add('is-in');
        });
        if (loadMoreBtn) {
            var remaining = matches.length - shownCount;
            loadMoreBtn.hidden = remaining <= 0;
            if (remaining > 0 && countEl) countEl.textContent = '(' + remaining + ')';
        }
    }

    filterBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
            currentFilter = btn.dataset.filter;
            shownCount = BATCH;
            filterBtns.forEach(function (b) {
                b.classList.toggle('is-active', b === btn);
                b.setAttribute('aria-selected', String(b === btn));
            });
            applyCases(true);
        });
    });

    if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', function () {
            shownCount += BATCH;
            applyCases(true);
        });
    }

    applyCases(false);

    // Case study drawer
    var drawer = document.getElementById('case-drawer');
    var projectData = [];
    try { projectData = JSON.parse(document.getElementById('project-data').textContent); } catch (e) {}

    function openDrawer(projectId) {
        var p = projectData.find(function (d) { return d.id === projectId; });
        if (!p || !drawer) return;

        document.getElementById('drawer-badge').textContent = p.type || '';
        document.getElementById('drawer-title').textContent = p.name || '';
        document.getElementById('drawer-date').textContent = p.date || '';

        // Main image
        var imgContainer = document.getElementById('drawer-img');
        imgContainer.innerHTML = '';
        if (p.images && p.images.length > 0) {
            var mainImg = document.createElement('img');
            mainImg.src = 'data:image/jpeg;base64,' + p.images[0];
            mainImg.alt = p.name;
            imgContainer.appendChild(mainImg);
        }

        // Gallery thumbnails
        var gallery = document.getElementById('drawer-gallery');
        gallery.innerHTML = '';
        if (p.images && p.images.length > 1) {
            p.images.forEach(function (base64, idx) {
                var thumb = document.createElement('img');
                thumb.src = 'data:image/jpeg;base64,' + base64;
                thumb.alt = p.name + ' screenshot ' + (idx + 1);
                if (idx === 0) thumb.classList.add('is-active');
                thumb.addEventListener('click', function () {
                    imgContainer.innerHTML = '';
                    var img = document.createElement('img');
                    img.src = thumb.src;
                    img.alt = thumb.alt;
                    imgContainer.appendChild(img);
                    gallery.querySelectorAll('img').forEach(function (t) { t.classList.remove('is-active'); });
                    thumb.classList.add('is-active');
                });
                gallery.appendChild(thumb);
            });
        }

        // Sections
        setSection('drawer-overview', 'drawer-overview-section', p.overview);
        setSection('drawer-challenge', 'drawer-challenge-section', p.challenge);
        setSection('drawer-solution', 'drawer-solution-section', p.solution);

        // Tech stack
        var techsEl = document.getElementById('drawer-techs');
        var techSection = document.getElementById('drawer-stack-section');
        techsEl.innerHTML = '';
        if (p.techs && p.techs.length > 0) {
            p.techs.forEach(function (cls) {
                var i = document.createElement('i');
                i.className = cls;
                i.title = cls.replace(/devicon-|-plain|-original|-plain-wordmark/g, '');
                techsEl.appendChild(i);
            });
            techSection.style.display = '';
        } else {
            techSection.style.display = 'none';
        }

        drawer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('drawer-open');
        // Focus the close button for a11y
        drawer.querySelector('.drawer__close').focus();
    }

    function setSection(contentId, sectionId, text) {
        var el = document.getElementById(contentId);
        var section = document.getElementById(sectionId);
        if (text) {
            el.textContent = text;
            section.style.display = '';
        } else {
            el.textContent = '';
            section.style.display = 'none';
        }
    }

    function closeDrawer() {
        if (!drawer) return;
        drawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('drawer-open');
    }

    // Open drawer from card click
    document.querySelectorAll('#cases-grid .card--case').forEach(function (card) {
        card.addEventListener('click', function (e) {
            // Don't intercept if they clicked a link inside
            if (e.target.closest('a')) return;
            openDrawer(parseInt(card.dataset.projectId, 10));
        });
    });

    // Close drawer
    if (drawer) {
        drawer.querySelector('.drawer__close').addEventListener('click', closeDrawer);
        drawer.querySelector('.drawer__backdrop').addEventListener('click', closeDrawer);
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
        });
    }

    // Contact form (progressive enhancement; falls back to normal POST)
    var form = document.getElementById('contact-form');
    var status = document.getElementById('form-status');
    if (form && window.fetch) {
        form.addEventListener('submit', function (e) {
            if (!form.checkValidity()) {
                e.preventDefault();
                form.reportValidity();
                return;
            }
            e.preventDefault();
            var btn = form.querySelector('button[type=submit]');
            btn.disabled = true;
            status.className = 'form__status';
            status.textContent = 'Sending…';
            fetch(form.action, {
                method: 'POST',
                headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                body: new FormData(form)
            }).then(function (r) {
                return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; });
            }).then(function (res) {
                var msg = res.j.message;
                if (!msg && res.j.errors) msg = Object.values(res.j.errors)[0][0];
                status.textContent = msg || (res.ok ? 'Message sent.' : 'Something went wrong. Please email me directly.');
                status.classList.add(res.ok ? 'is-ok' : 'is-err');
                if (res.ok) form.reset();
            }).catch(function () {
                status.textContent = 'Network error. Please email me directly.';
                status.classList.add('is-err');
            }).then(function () { btn.disabled = false; });
        });
    }
})();
